import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { CheckCircle2, RotateCcw, Eye, Package, User, FileText, MapPin, Trash2, RotateCcw as RefreshCcw, UserPlus } from "lucide-react";
import { toast } from "react-toastify";


import { IconButton, TextButton } from "../../../components/ButtonComponents";
import { TableActions } from "../../../components/TableActions";
import { useWarehouseTaskStore, useWarehouseShortageStore } from "../../../store/warehouseTask";
import { DateRangePicker } from "../../../components/DateRangePicker";
import { Tag } from "primereact/tag";
import { MultiSelect } from "primereact/multiselect";

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { EDataTable } from "../../../components/EDataTable";
import { Filter, QueryParams, DataTableColumn } from "../../../types";
import { WarehouseTaskDetailDialog } from "./WarehouseTaskDetailDialog";
import { formatQuantity } from "../../../utils/format";
export const WarehouseShortageMonitor = () => {
  const taskStore = useWarehouseTaskStore();
  const shortageStore = useWarehouseShortageStore();

  // Filtre State'leri
  const [filterStatuses, setFilterStatuses] = useState<string[]>([]);
  const [filterDates, setFilterDates] = useState<(Date | null)[] | null>(null);
  const [filterAssignedUsers, setFilterAssignedUsers] = useState<number[]>([]);

  // Aksiyon Dialog State'leri
  const [resolveDialogVisible, setResolveDialogVisible] = useState(false);
  const [cancelDialogVisible, setCancelDialogVisible] = useState(false);
  const [unresolveDialogVisible, setUnresolveDialogVisible] = useState(false);
  const [assignDialogVisible, setAssignDialogVisible] = useState(false);
  const [previewDialogVisible, setPreviewDialogVisible] = useState(false);
  const [taskDetailDialogVisible, setTaskDetailDialogVisible] = useState(false);
  const [selectedShortage, setSelectedShortage] = useState<any>(null);
  const [selectedTaskDetails, setSelectedTaskDetails] = useState<any>(null);

  const [isUnavailable, setIsUnavailable] = useState(false); // resolve için
  const [selectedStaffId, setSelectedStaffId] = useState<number | null>(null);
  const [staffList, setStaffList] = useState<any[]>([]);
  const [submitting, setSubmitting] = useState(false);

  // Durum seçenekleri
  const statusOptions = [
    { label: "Açık Eksik (Toplama)", value: "REPORTED_BY_PICKER" },
    { label: "Açık Eksik (Paketleme)", value: "REPORTED_BY_PACKER" },
    { label: "Genel Eksik (Takviyeci)", value: "REPORTED_BY_PREPARER" },
    { label: "Tedarik Bekliyor", value: "WAITING_FOR_SUPPLY" },
    { label: "Çözüldü", value: "RESOLVED" },
  ];

  const extraFilters = useMemo(() => {
    const filters: Filter[] = [];

    // Durum Filtresi
    if (filterStatuses.length > 0) {
      filters.push({
        field: "status",
        operator: "in" as any,
        value: filterStatuses,
      });
    }

    // Tarih Aralığı Filtresi
    if (filterDates && Array.isArray(filterDates) && filterDates[0] && filterDates[1]) {
      const startDate = new Date(filterDates[0]);
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(filterDates[1]);
      endDate.setHours(23, 59, 59, 999);

      filters.push({
        logic: "and",
        filters: [
          { field: "createdAt", operator: "gte", value: startDate.toISOString() },
          { field: "createdAt", operator: "lte", value: endDate.toISOString() },
        ],
      } as any);
    }

    // Atanan Personel Filtresi
    if (filterAssignedUsers && filterAssignedUsers.length > 0) {
      filters.push({
        field: "assignedUserId",
        operator: "in" as any,
        value: filterAssignedUsers,
      });
    }

    return filters;
  }, [filterStatuses, filterDates, filterAssignedUsers]);

  const refreshTable = useCallback(() => {
    shortageStore.fetchDataDynamic();
  }, [shortageStore]);

  // --- FETCH STAFF ---
  const loadStaff = async () => {
    try {
      const staff = await taskStore.getStaffList();
      setStaffList(staff);
    } catch (err) {
      toast.error("Personel listesi alınamadı.");
    }
  };

  useEffect(() => {
    loadStaff();
  }, []);

  // --- API AKSİYONLARI ---

  const handleResolve = async () => {
    if (!selectedShortage) return;

    setSubmitting(true);
    const loadToast = toast.loading("Eksik çözülüyor...");
    try {
      if (isUnavailable) {
        await shortageStore.markUnavailable(selectedShortage.id);
      } else {
        await shortageStore.resolveShortage(selectedShortage.id);
      }

      toast.update(loadToast, { render: "Eksik başarıyla çözüldü.", type: "success", isLoading: false, autoClose: 3000 });
      setResolveDialogVisible(false);
      refreshTable();
    } catch (e) {
      toast.update(loadToast, { render: "İşlem başarısız oldu.", type: "error", isLoading: false, autoClose: 3000 });
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = async () => {
    if (!selectedShortage) return;

    setSubmitting(true);
    const loadToast = toast.loading("Eksik bildirimi iptal ediliyor...");
    try {
      await shortageStore.cancelShortage(selectedShortage.id);

      toast.update(loadToast, { render: "Eksik kaydı başarıyla silindi/iptal edildi.", type: "success", isLoading: false, autoClose: 3000 });
      setCancelDialogVisible(false);
      refreshTable();
    } catch (e) {
      toast.update(loadToast, { render: "İşlem başarısız oldu.", type: "error", isLoading: false, autoClose: 3000 });
    } finally {
      setSubmitting(false);
    }
  };

  const handleUnresolve = async () => {
    if (!selectedShortage) return;

    setSubmitting(true);
    const loadToast = toast.loading("Eksik tekrar açılıyor...");
    try {
      await shortageStore.unresolveShortage(selectedShortage.id);

      toast.update(loadToast, { render: "Eksik başarıyla tekrar incelemeye alındı.", type: "success", isLoading: false, autoClose: 3000 });
      setUnresolveDialogVisible(false);
      refreshTable();
    } catch (e) {
      toast.update(loadToast, { render: "İşlem başarısız oldu.", type: "error", isLoading: false, autoClose: 3000 });
    } finally {
      setSubmitting(false);
    }
  };

  const handleAssign = async () => {
    if (!selectedShortage || !selectedStaffId) return;
    setSubmitting(true);
    const loadToast = toast.loading("Atama yapılıyor...");
    try {
      await shortageStore.assignShortage(selectedShortage.id, { assignedUserId: selectedStaffId });
      toast.update(loadToast, { render: "Atama başarıyla tamamlandı.", type: "success", isLoading: false, autoClose: 3000 });
      setAssignDialogVisible(false);
      refreshTable();
    } catch (e) {
      toast.update(loadToast, { render: "Atama başarısız oldu.", type: "error", isLoading: false, autoClose: 3000 });
    } finally {
      setSubmitting(false);
    }
  };

  // Dialogları açan yardımcı fonksiyonlar
  const openResolveDialog = (shortage: any) => {
    setSelectedShortage(shortage);
    setIsUnavailable(shortage.status === "WAITING_FOR_SUPPLY" ? true : false);
    setResolveDialogVisible(true);
  };

  const openAssignDialog = (shortage: any) => {
    setSelectedShortage(shortage);
    setSelectedStaffId(shortage.assignedUserId || null);
    setAssignDialogVisible(true);
  };

  const openCancelDialog = (shortage: any) => {
    setSelectedShortage(shortage);
    setCancelDialogVisible(true);
  };

  const openUnresolveDialog = (shortage: any) => {
    setSelectedShortage(shortage);
    setUnresolveDialogVisible(true);
  };

  const openPreviewDialog = (shortage: any) => {
    setSelectedShortage(shortage);
    setPreviewDialogVisible(true);
  };

  const openTaskDetail = async (taskId: number) => {
    const loadToast = toast.loading("Görev detayı yükleniyor...");
    try {
      const fullTask = await taskStore.getSingleTask(taskId);
      setSelectedTaskDetails(fullTask);
      toast.dismiss(loadToast);
      setTaskDetailDialogVisible(true);
    } catch (e) {
      toast.update(loadToast, { render: "Görev detayları alınamadı.", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  // --- TABLO KOLONLARI ---

  const columns = useMemo<DataTableColumn<any>[]>(() => [
    {
      field: "stock.name",
      header: "Ürün Bilgisi",
      sortable: true,
      width: "280px",
      body: (r) => (
        <div className="flex flex-col">
          <span className="font-semibold text-sm truncate" title={r.stock?.name}>{r.stock?.name || "-"}</span>
          <span className="text-xs text-gray-500 font-mono">{r.stock?.sku || "-"}</span>
        </div>
      ),
    },
    {
      field: "missingQty",
      header: "Eksik",
      sortable: true,
      width: "100px",
      body: (r) => (
        <span className="font-bold text-red-600 bg-red-50 dark:bg-red-900/20 px-2 py-1 rounded">
          {formatQuantity(r.missingQty)}
        </span>
      ),
    },
    {
      field: "task.order.orderNumber",
      header: "Kaynak / Sipariş",
      sortable: true,
      width: "220px",
      body: (r) => {
        if (!r.taskId) {
          return (
            <span className="px-2 py-1 bg-gray-100 text-gray-700 font-bold text-[11px] rounded uppercase tracking-wider">
              GENEL DEPO EKSİĞİ
            </span>
          );
        }
        return (
          <div
            className="flex flex-col cursor-pointer hover:bg-blue-50 p-1 rounded transition-colors"
            onClick={(e) => { e.stopPropagation(); openTaskDetail(r.taskId); }}
            title="Görev Detayını Gör"
          >
            <div className="flex items-center gap-1">
              <FileText size={12} className="text-blue-500" />
              <span className="font-mono font-bold text-blue-600">
                #{r.task?.order?.orderNumber || r.taskId}
              </span>
            </div>
            <span className="text-[11px] text-gray-500 truncate" title={r.task?.order?.account?.name}>
              {r.task?.order?.account?.name || "-"}
            </span>
          </div>
        );
      },
    },
    {
      field: "createdAt",
      header: "Tarih",
      sortable: true,
      width: "160px",
      body: (r) => (
        <span className="text-sm">
          {new Date(r.createdAt).toLocaleString("tr-TR")}
        </span>
      ),
    },
    {
      field: "description",
      header: "Eksik Notu",
      sortable: false,
      width: "220px",
      body: (r) => (
        <span className="text-xs text-gray-600 italic truncate block max-w-full" title={r.description}>
          {r.description || "-"}
        </span>
      ),
    },
    {
      field: "task.order.shippingAddress.addressLine",
      header: "Sevkiyat Adresi",
      sortable: false,
      width: "240px",
      body: (r) => {
        const address = r.task?.order?.shippingAddress?.addressLine;
        if (!address) return <span className="text-gray-400">-</span>;
        return (
          <div className="group relative flex items-center w-full overflow-hidden">
            <span className="truncate text-xs text-gray-700 transition-all duration-200" title={address}>
              {address}
            </span>

            {/* Buton absolute olarak sağda durur. Sadece hover durumunda görünür olur. Böylece dar kolonda metin okunur, hover ile aksiyon alınır */}
            <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity bg-gradient-to-l from-white via-white to-transparent pl-4 pr-1 flex items-center">
              <IconButton
                icon={MapPin}
                className="w-7 h-7 text-blue-500 bg-blue-50 hover:bg-blue-100"
                onClick={(e) => {
                  e.stopPropagation();
                  toast.info(`Adres: ${address}`);
                }}
                title="Adresi Haritada Gör (Örnek)"
              />
            </div>
          </div>
        );
      }
    },
    {
      field: "reportedBy.name",
      header: "Bildiren",
      sortable: true,
      width: "160px",
      body: (r) => (
        <span className="text-sm font-medium">
          {r.reportedBy?.name || "-"}
        </span>
      ),
    },
    {
      field: "assignedUser.name",
      header: "Sorumlu",
      sortable: true,
      width: "190px",
      body: (r) => (
        <div
          className="flex items-center justify-between p-2 rounded-lg border border-borderColor cursor-pointer  transition-colors  shadow-sm"
          onClick={(e) => { e.stopPropagation(); openAssignDialog(r); }}
          title="Atamayı Değiştir"
        >
          <div className="flex items-center gap-1 overflow-hidden pr-1">
            <span className="text-[11px] font-bold text-purple-600 uppercase tracking-wide">
              Atanan:
            </span>
            {r.assignedUser ? (
              <span className="text-[12px] font-semibold text-gray-800 truncate">
                {r.assignedUser.name}
              </span>
            ) : (
              <span className="text-[12px] text-orange-500 font-bold animate-pulse">
                ATA
              </span>
            )}
          </div>
          <UserPlus size={14} className="text-purple-400 shrink-0" />
        </div>
      ),
    },
    {
      field: "status",
      header: "Durum",
      sortable: true,
      width: "170px",
      body: (r) => {
        if (r.status === "REPORTED_BY_PICKER") {
          return <Tag value="Toplama Eksiği" severity="danger" className="text-[10px] px-2 py-1" />;
        } else if (r.status === "REPORTED_BY_PACKER") {
          return <Tag value="Paketleme Eksiği" severity="danger" className="text-[10px] px-2 py-1" />;
        } else if (r.status === "REPORTED_BY_PREPARER") {
          return <Tag value="Genel Eksik" severity="danger" className="text-[10px] px-2 py-1" />;
        } else if (r.status === "WAITING_FOR_SUPPLY") {
          return <Tag value="Tedarik Bekliyor" severity="warning" className="text-[10px] px-2 py-1" />;
        } else if (r.status === "RESOLVED") {
          return <Tag value="Çözüldü" severity="success" className="text-[10px] px-2 py-1" />;
        }
        return <Tag value={r.status} severity="info" className="text-[10px] px-2 py-1" />;
      },
    },
    {
      field: "actions",
      header: "İşlemler",
      align: "center",
      width: "150px",
      body: (r) => (
        <TableActions
          actions={[
            {
              icon: Eye,
              colorClass: "text-blue-600 hover:bg-blue-50",
              title: "Detayları Gör",
              onClick: (e) => { e.stopPropagation(); openPreviewDialog(r); }
            },
            {
              icon: CheckCircle2,
              colorClass: "text-green-600 hover:bg-green-50",
              title: "Eksiği Çöz / Tedarik Beklet",
              onClick: (e) => { e.stopPropagation(); openResolveDialog(r); },
              show: !r.isResolved
            },
            {
              icon: Trash2,
              colorClass: "text-red-600 hover:bg-red-50",
              title: "İptal Et / Sil",
              onClick: (e) => { e.stopPropagation(); openCancelDialog(r); },
              show: !r.isResolved
            },
            {
              icon: RefreshCcw,
              colorClass: "text-orange-600 hover:bg-orange-50",
              title: "Tekrar Aç",
              onClick: (e) => { e.stopPropagation(); openUnresolveDialog(r); },
              show: r.isResolved
            }
          ]}
        />
      ),
    }
  ], []);

  // --- FİLTRE BARI ---

  const filterBar = (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex flex-col gap-1 w-full sm:w-auto">
        <label className="text-xs font-semibold text-gray-500">Tarih Aralığı</label>
        <DateRangePicker
          value={filterDates}
          onChange={setFilterDates}
        />
      </div>

      <div className="flex flex-col gap-1 w-full sm:w-auto">
        <label className="text-xs font-semibold text-gray-500">Durum</label>
        <MultiSelect
          value={filterStatuses}
          options={statusOptions}
          onChange={(e) => setFilterStatuses(e.value)}
          placeholder="Durum Seçin"
          className="w-full sm:w-64"
          display="chip"
        />
      </div>

      <div className="flex flex-col gap-1 w-full sm:w-auto min-w-[150px]">
        <label className="text-xs font-semibold text-gray-500">Atanan Personel</label>
        <MultiSelect
          value={filterAssignedUsers}
          options={staffList}
          onChange={(e) => setFilterAssignedUsers(e.value)}
          placeholder="Tümü"
          className="w-full md:w-48"
          display="chip"
          filter
        />
      </div>

      {/* Easter Egg: Bülent Ersoy Meemi (İçimden geldi bu yoktu) */}
      <div className="ml-auto flex items-end justify-end self-end">
        <a
          href="https://www.youtube.com/watch?v=2ZHK-hVhELc"
          target="_blank"
          rel="noreferrer"
          className="opacity-5 hover:opacity-100 transition-opacity duration-1000 z-50 mb-1"
          title="İçimden geldi, bu yoktu!"
        >
          <img
            src="https://api.qrserver.com/v1/create-qr-code/?size=80x80&data=https://www.youtube.com/watch?v=2ZHK-hVhELc"
            alt="Easter Egg"
            className="w-16 h-16 grayscale hover:grayscale-0 shadow-sm rounded"
          />
        </a>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="card p-0 shadow-lg border-0 h-full flex flex-col">
        <EDataTable<any>
          tableKey="warehouse_shortage_monitor"
          placeholder="Ürün adı veya SKU ile ara..."
          searchFields={[
            { field: "stock.name", operator: "contains" },
            { field: "stock.sku", operator: "contains" }
          ]}
          useStore={() => shortageStore}
          dataKey="id"
          title="Eksik Ürünler (Shortages)"
          subTitle="Depodaki eksik bildirimlerini yönetin ve çözüme kavuşturun."
          filters={extraFilters}
          filterBar={filterBar}
          columns={columns as any}
          scrollh={380}

        />
      </div>

      {/* --- PREVIEW DIALOG --- */}
      <Dialog
        header={
          <div className="flex items-center gap-2">
            <Eye className="text-blue-600" size={24} />
            <span className="font-bold">Eksik Ürün Detayı</span>
          </div>
        }
        visible={previewDialogVisible}
        style={{ width: "50vw", minWidth: "600px" }}
        onHide={() => setPreviewDialogVisible(false)}
      >
        {selectedShortage && (
          <div className="flex flex-col gap-6 pt-4">

            {/* Üst Kısım: Ürün ve Eksik Özeti */}
            <div className="flex items-start gap-4 p-4 rounded-xl border border-red-100 bg-red-50/50">
              <div className="flex-1 flex flex-col gap-1">
                <span className="text-red-700 font-bold text-lg">Eksik Bildirimi</span>
                <span className="text-sm text-red-900/80">{selectedShortage.description || "Not girilmemiş."}</span>
              </div>
              <div className="flex flex-col items-end gap-1">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest">Eksik Miktar</span>
                <span className="text-2xl font-black text-red-600">{formatQuantity(selectedShortage.missingQty)}</span>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Sol Kolon: Ürün Detayları */}
              <div className="flex flex-col gap-3 p-4 rounded-xl border border-gray-200">
                <div className="flex items-center gap-2 text-gray-800 border-b pb-2">
                  <Package size={18} className="text-primary" />
                  <span className="font-bold">Ürün Bilgileri</span>
                </div>

                <div className="flex flex-col gap-1">
                  <span className="text-xs text-gray-500">Ürün Adı</span>
                  <span className="text-sm font-semibold">{selectedShortage.stock?.name}</span>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  <div className="flex flex-col gap-1">
                    <span className="text-xs text-gray-500">SKU</span>
                    <span className="text-sm font-mono">{selectedShortage.stock?.sku}</span>
                  </div>
                  <div className="flex flex-col gap-1">
                    <span className="text-xs text-gray-500">Mevcut Toplam Stok</span>
                    <span className="text-sm font-semibold">{formatQuantity(selectedShortage.stock?.quantity)}</span>
                  </div>
                </div>

                {selectedShortage.stock?.stockLocations && selectedShortage.stock.stockLocations.length > 0 && (
                  <div className="mt-2 flex flex-col gap-1">
                    <span className="text-xs text-gray-500">Depo Raf Konumları</span>
                    <div className="flex flex-col gap-1 mt-1">
                      {selectedShortage.stock.stockLocations.map((loc: any) => (
                        <div key={loc.id} className="flex justify-between items-center bg-gray-50 px-2 py-1 rounded text-xs">
                          <span className="font-medium text-gray-700">{loc.location?.name}</span>
                          <span className="text-gray-500">Miktar: <b className="text-gray-800">{formatQuantity(loc.quantity)}</b></span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Sağ Kolon: Sipariş ve Görev Detayları */}
              {selectedShortage.taskId ? (
                <div className="flex flex-col gap-3 p-4 rounded-xl border border-gray-200">
                  <div className="flex items-center gap-2 text-gray-800 border-b pb-2">
                    <FileText size={18} className="text-primary" />
                    <span className="font-bold">Sipariş & Görev Bilgileri</span>
                  </div>

                  <div className="flex flex-col gap-1">
                    <span className="text-xs text-gray-500">Sipariş No</span>
                    <span className="text-sm font-mono font-bold text-blue-600">{selectedShortage.task?.order?.orderNumber}</span>
                  </div>

                  <div className="flex flex-col gap-1">
                    <span className="text-xs text-gray-500">Müşteri</span>
                    <span className="text-sm font-medium">{selectedShortage.task?.order?.account?.name}</span>
                  </div>

                  <div className="flex flex-col gap-1 mt-2">
                    <span className="text-xs text-gray-500 flex items-center gap-1">
                      <MapPin size={12} /> Teslimat Adresi
                    </span>
                    <span className="text-xs text-gray-700 line-clamp-2">
                      {selectedShortage.task?.order?.shippingAddress?.addressLine || "-"}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col justify-center items-center gap-3 p-4 rounded-xl border border-dashed border-gray-300 bg-gray-50 text-gray-500">
                  <Package size={32} className="opacity-50" />
                  <span className="font-semibold text-sm">Genel Depo Eksiği</span>
                  <span className="text-xs text-center">Bu bildirim belirli bir siparişe bağlı olarak değil, doğrudan depodan yapılmıştır.</span>
                </div>
              )}
            </div>

            {/* Alt Kısım: Bildiren Kişi */}
            <div className="flex items-center gap-2 bg-blue-50 text-blue-800 p-3 rounded-lg text-sm">
              <User size={16} />
              <span>Bu eksik <b>{selectedShortage.reportedBy?.name || "Bilinmiyor"}</b> tarafından <b>{new Date(selectedShortage.createdAt).toLocaleString("tr-TR")}</b> tarihinde bildirildi.</span>
            </div>

          </div>
        )}
      </Dialog>

      {/* --- RESOLVE DIALOG --- */}
      <Dialog
        header="Eksiği Çöz"
        visible={resolveDialogVisible}
        style={{ width: "30vw", minWidth: "350px" }}
        onHide={() => setResolveDialogVisible(false)}
        footer={
          <div className="flex justify-end gap-2">
            <button
              onClick={() => setResolveDialogVisible(false)}
              className="p-button-text text-gray-500 hover:bg-gray-100 px-4 py-2 rounded transition-colors"
              disabled={submitting}
            >
              İptal
            </button>
            <button
              onClick={handleResolve}
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded flex items-center gap-2 transition-colors disabled:opacity-50"
              disabled={submitting}
            >
              {submitting ? "İşleniyor..." : "Çözüldü İşaretle"}
            </button>
          </div>
        }
      >
        <div className="flex flex-col gap-4 pt-2">
          <p className="text-sm text-gray-600">
            Eksik ürün bulunduysa onaylayabilirsiniz. Eğer ürün depoda gerçekten yoksa "Tedarik Edilemiyor" olarak işaretleyin.
          </p>
          <div className="flex items-center gap-2 mt-2 cursor-pointer" onClick={() => setIsUnavailable(!isUnavailable)}>
            <div className={`w-5 h-5 rounded border flex items-center justify-center ${isUnavailable ? 'bg-red-500 border-red-500' : 'border-gray-300'}`}>
              {isUnavailable && <CheckCircle2 size={14} className="text-white" />}
            </div>
            <label className="text-sm font-medium cursor-pointer select-none">
              Bu ürün depoda yok (Tedarik Edilemiyor)
            </label>
          </div>
        </div>
      </Dialog>

      {/* --- CANCEL DIALOG --- */}
      <Dialog
        header="Eksik Bildirimini İptal Et"
        visible={cancelDialogVisible}
        style={{ width: "30vw", minWidth: "350px" }}
        onHide={() => setCancelDialogVisible(false)}
        footer={
          <div className="flex justify-end gap-2">
            <button
              onClick={() => setCancelDialogVisible(false)}
              className="p-button-text text-gray-500 hover:bg-gray-100 px-4 py-2 rounded transition-colors"
              disabled={submitting}
            >
              Vazgeç
            </button>
            <button
              onClick={handleCancel}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded flex items-center gap-2 transition-colors disabled:opacity-50"
              disabled={submitting}
            >
              {submitting ? "Siliniyor..." : "Sil / İptal Et"}
            </button>
          </div>
        }
      >
        <div className="flex flex-col gap-4 pt-2">
          <p className="text-sm text-gray-600">
            Bu eksik bildirimi yanlışlıkla açılmış olabilir. Bu işlemi onayladığınızda eksik kaydı <b>tamamen silinecektir</b>.
          </p>
          <p className="text-xs text-red-600 font-bold bg-red-50 p-2 rounded border border-red-100">
            Uyarı: İlgili sipariş eksiklikten dolayı duraklatıldıysa tekrar aktif hale gelecektir.
          </p>
        </div>
      </Dialog>

      {/* --- UNRESOLVE DIALOG --- */}
      <Dialog
        header="Eksik Bildirimini Tekrar Aç"
        visible={unresolveDialogVisible}
        style={{ width: "30vw", minWidth: "350px" }}
        onHide={() => setUnresolveDialogVisible(false)}
        footer={
          <div className="flex justify-end gap-2">
            <button
              onClick={() => setUnresolveDialogVisible(false)}
              className="p-button-text text-gray-500 hover:bg-gray-100 px-4 py-2 rounded transition-colors"
              disabled={submitting}
            >
              İptal
            </button>
            <button
              onClick={handleUnresolve}
              className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded flex items-center gap-2 transition-colors disabled:opacity-50"
              disabled={submitting}
            >
              {submitting ? "İşleniyor..." : "Tekrar Aç"}
            </button>
          </div>
        }
      >
        <div className="flex flex-col gap-4 pt-2">
          <p className="text-sm text-gray-600">
            Daha önce çözüldü olarak işaretlenmiş bu eksik kaydını tekrar "Açık" duruma getirmek üzeresiniz.
          </p>
          <p className="text-xs text-orange-600 font-bold bg-orange-50 p-2 rounded border border-orange-100">
            İlgili görevler tekrar inceleme moduna (SHORTAGE) dönecektir.
          </p>
        </div>
      </Dialog>

      {/* --- ASSIGN DIALOG --- */}
      <Dialog
        header="Eksik İçin Personel Ata"
        visible={assignDialogVisible}
        style={{ width: "30vw", minWidth: "350px" }}
        onHide={() => setAssignDialogVisible(false)}
        footer={
          <div className="flex justify-end gap-2">
            <button
              onClick={() => setAssignDialogVisible(false)}
              className="p-button-text text-gray-500 hover:bg-gray-100 px-4 py-2 rounded transition-colors"
              disabled={submitting}
            >
              İptal
            </button>
            <button
              onClick={handleAssign}
              className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded flex items-center gap-2 transition-colors disabled:opacity-50"
              disabled={submitting || !selectedStaffId}
            >
              {submitting ? "Atanıyor..." : "Ata"}
            </button>
          </div>
        }
      >
        <div className="flex flex-col gap-4 pt-2">
          <p className="text-sm text-gray-600">
            Eksiği hazırlaması veya tedarik etmesi için bir depo personeli seçin. Seçilen personele anlık bildirim gidecektir.
          </p>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold">Personel Seçin</label>
            <Dropdown
              value={selectedStaffId}
              options={staffList}
              onChange={(e) => setSelectedStaffId(e.value)}
              placeholder="Personel seçiniz"
              className="w-full"
              filter
            />
          </div>
        </div>
      </Dialog>

      {/* --- TASK DETAIL DIALOG --- */}
      {selectedTaskDetails && (
        <WarehouseTaskDetailDialog
          isOpen={taskDetailDialogVisible}
          onClose={() => {
            setTaskDetailDialogVisible(false);
            setSelectedTaskDetails(null);
            refreshTable(); // Görev detayında yapılan değişiklikler ana tabloyu etkileyebilir
          }}
          task={selectedTaskDetails}
        />
      )}
    </div>
  );
};
